import { Fragment } from 'react';
import FileInput from '../../../components/FileInput';
import { RadioGroup } from '../../../components/Radio';
import SelectableCard from '../../../components/SelectableCard';

export type StepProps = {
  data: any;
  collectStepData: (data: any) => void;
};

const VerifyDependentStep2 = ({ data, collectStepData }: StepProps) => {
  const handleRelationshioDocChange = (e: string | number) => {
    collectStepData({
      ...data,
      birthCertificateOption: e,
    });
  };

  const handleFileChange = (isValid: boolean) => {
    collectStepData({
      ...data,
      isFileValid: isValid,
    });
  };

  return (
    <Fragment>
      <section className={'mt-11 pt-2 pt-lg-1'}>
        <h5 className={'h5 mb-0'}>
          {
            'Provide documentation regarding your relationship with the dependent'
          }
        </h5>
        <h5 className={'text-sm-20-lg-24 mt-12 mt-lg-11 pt-lg-1'}>
          {'Birth Certificate'}
        </h5>
        <div className={'text-fs-6 mt-3 fw-light'}>
          {'How would you like to send the documentation?'}
        </div>
        <div className={'mt-6 mt-lg-10'}>
          <RadioGroup
            name={'step-1'}
            value={data.birthCertificateOption}
            onChange={handleRelationshioDocChange}
          >
            <SelectableCard
              title="File upload"
              radioButtonValue="1"
              selected={data.birthCertificateOption === '1'}
            >
              <section className={'ms-lg-13 pb-10 ps-10 ps-lg-13 pe-10 lh-xs'}>
                <FileInput
                  placeholder={'filename.pdf'}
                  className="mw-100 mr-2"
                  width="420px"
                  onValidate={handleFileChange}
                />
              </section>
            </SelectableCard>
            <SelectableCard
              title="Mail/Fax"
              radioButtonValue="2"
              selected={data.birthCertificateOption === '2'}
            >
              <section className={'ms-13 pb-3 ps-10 ps-lg-13 pe-10 lh-xs'}>
                <div className={'text-fs-6 fw-light'}>
                  {'Instructions for sending document to service center'}
                </div>
                <div
                  className={
                    'mt-8 pb-4 border-bottom border-info text-fs-6 fw-light d-flex'
                  }
                >
                  <span
                    className={' d-inline-block flex-shrink-0 fw-normal me-7'}
                  >
                    {'Step 1'}
                  </span>
                  {'Print the cover sheet provided on the completed page.'}
                </div>
                <div
                  className={
                    'mt-8 pb-4 border-bottom border-info text-fs-6 fw-light d-flex'
                  }
                >
                  <span
                    className={'d-inline-block flex-shrink-0 fw-normal me-7'}
                  >
                    {'Step 2'}
                  </span>
                  {'Gather required documentation'}
                </div>
                <div
                  className={
                    'mt-8 pb-4 border-bottom border-info text-fs-6 fw-light d-flex'
                  }
                >
                  <span
                    className={'d-inline-block flex-shrink-0 fw-normal me-7'}
                  >
                    {'Step 3'}
                  </span>
                  {'Send Mail/Fax'}
                </div>
                <ul className={'ps-10 mt-4 lh-xs'}>
                  <li className={'text-fs-6 fw-light'}>
                    {
                      'Include the cover sheet as your first page with the required documentation in step 2.'
                    }
                  </li>
                  <li className={'text-fs-6 fw-light'}>
                    {
                      'Mailing address and fax number is noted on the cover sheet.'
                    }
                  </li>
                  <li className={'text-fs-6 fw-light'}>
                    {'If mailing do not staple.'}
                  </li>
                </ul>
              </section>
            </SelectableCard>
          </RadioGroup>
        </div>
      </section>
    </Fragment>
  );
};

export default VerifyDependentStep2;
